import { render, staticRenderFns } from "./CarouselSection.vue?vue&type=template&id=35fc3ff7&scoped=true"
import script from "./CarouselSection.vue?vue&type=script&lang=js"
export * from "./CarouselSection.vue?vue&type=script&lang=js"
import style0 from "./CarouselSection.vue?vue&type=style&index=0&id=35fc3ff7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fc3ff7",
  null
  
)

export default component.exports